export default __webpack_public_path__ + "static/media/Reyan.e8e2a91f.png";